/**
 * NetworkGraphTest
 *
 * NetworkGraph 컴포넌트 테스트 페이지
 */

import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { NetworkGraph } from '../components/YearEnd/NetworkGraph';
import networkData from '../data/yearEndNetwork.json';

const NetworkGraphTest = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Network Graph Test
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {networkData.stats.nodeCount} nodes / {networkData.stats.linkCount} links
        {' • '}
        Weight: {networkData.stats.minWeight} ~ {networkData.stats.maxWeight}
      </Typography>

      <Box
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <NetworkGraph
          data={networkData}
          minWeight={20}
          height={700}
        />
      </Box>
    </Container>
  );
};

export default NetworkGraphTest;
